import Toast from 'react-bootstrap/Toast';

const ToastView = ({title, message, shouldShow, showToggle}:
	{title?: string, message?: string, shouldShow:boolean, showToggle:()=>void}) => {
	return (
		<Toast style={{width:'90%', margin:'auto'}} show={shouldShow} onClose={showToggle}>
			<Toast.Header>
				{/* <img
					src="holder.js/20x20?text=%20"
					className="rounded me-2"
					alt=""
				/> */}
				<strong className="me-auto">{title && title}</strong>
			</Toast.Header>
			<Toast.Body>{message && message}</Toast.Body>
        </Toast>
	)
}

export default ToastView;